"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartAndEndTime = void 0;
const local_time_1 = require("./local-time");
class StartAndEndTime {
    constructor(obj) {
        // TODO check if start < end, switch if necessary
        this.start = new local_time_1.LocalTime(obj.start);
        this.end = new local_time_1.LocalTime(obj.end);
    }
    toString() {
        return `${this.start}-${this.end}`;
    }
}
exports.StartAndEndTime = StartAndEndTime;
//# sourceMappingURL=start-and-end-time.js.map